import ReviewsSectionBase from "@/components/sections/products/shared/reviews-base";
import { STATS } from "@/lib/constants";

interface Props {
  /** Hide reviews explicitly tagged as being about this other product line. */
  excludeProduct?: "mobile" | "residential";
}

export default function ReviewsSection({ excludeProduct }: Props) {
  return (
    <ReviewsSectionBase
      headingId="reviews-heading"
      heading={`Trusted by ${STATS.customers} of teams.`}
      body="Real feedback from engineers, growth teams, and agencies who rely on Proxidize daily."
      excludeProduct={excludeProduct}
    />
  );
}
